// extracted by mini-css-extract-plugin
export default {"imgMagnifierContainer":"ImageMagnifier_imgMagnifierContainer__+xBpL","image":"ImageMagnifier_image__dwzM6"};